<template>
  <div class="header_height">
    <header class="template_navbar header_in map_view header_height">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-12">
            <div id="logo">
              <a href="/">
                <img
                  src="../../assets/img/logo_sticky.png"
                  width="145"
                  height="35"
                  alt=""
                  class="logo_sticky"
                >
              </a>
            </div>
          </div>
          <div class="col-lg-9 col-12">
            <NavBarComponents />
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>

import NavBarComponents from './NavBarComponents';

export default {
  name: 'NavBar',

  components: {
    NavBarComponents,
  },
};
</script>
